type API_ENDPOINT = { URL: string; method: string }
export const API_INIT_ENDPOINT: API_ENDPOINT = { URL: '/api/v1/skipper/chats', method: 'POST' }
export const API_SEND_ENDPOINT: API_ENDPOINT = { URL: '/api/v1/skipper/chats/{chatID}', method: 'PUT' }
export const API_COMMAND_ENDPOINT: API_ENDPOINT = { URL: '/api/v1/skipper/chats/{chatID}/command', method: 'PUT' }
export const API_GLOBAL_COMMAND_ENDPOINT: API_ENDPOINT = { URL: '/api/v1/skipper/chats/command', method: 'PUT' }
export const API_CHECK_ENDPOINT: API_ENDPOINT = { URL: '/api/v1/skipper/chats/{chatID}/messages', method: 'POST' }
export const API_RATE_ENDPOINT: API_ENDPOINT = {
  URL: '/api/v1/skipper/chats/{chatID}/messages/{messageID}/rate',
  method: 'PUT'
}

export const DEFAULT_POLL_MS = 2500
export const IDLE_POLL_MS = 15000

export const DISCLAIMER_TEXT = 'Skipper can make mistakes. Check important info.'
